
<div class="bar-graph">
  <ng-container *ngFor="let category of workOrders">
    <div class="label">
      {{category.label}}
    </div>
    <div class="number">
      {{category.value}}
    </div>
    <div class="bar-wrapper" (click)="onRowClick(category)">
      <div class="bar" [ngClass]="category.color" [style.width.%]="category.value / max * 100"></div>
    </div>
  </ng-container>
</div>
